import script from "./EmailLinkAndRetreaver.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailLinkAndRetreaver.vue?vue&type=script&setup=true&lang=js"

import "./EmailLinkAndRetreaver.vue?vue&type=style&index=0&id=16c2d3dd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c2d3dd"]])

export default __exports__